import { Box } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';
import { TitleModal, NoteTypography } from '../../../MyAccount/common';
import { useLanguage } from '../../../../context/language/language';
import useDeliveryControlFlow from '../../../common/hook/useDeliveryControlFlow';
import { Button, ModalInfo } from '../../../common';
import { getImageURL } from '../../../../utils/getImageURL';

const ErrorIcon = getImageURL('/images/error.svg');

const Main = styled.div(({ theme }) => ({
  // padding: theme.isMobile ? 16 : 25,
  width: theme.isMobile ? 'auto' : '400px',
  minHeight: theme.isMobile ? '190px' : 'auto',
}));

const Container = styled.div(() => ({
  padding: 20,
}));

const Row = styled.div(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));
const FlexRow = styled(Box)(({ width, margin, justifyContent }) => ({
  display: 'flex',
  flexDirection: 'row',
  width,
  margin,
  justifyContent: justifyContent ?? 'center',
  alignContent: 'center',
}));

const BtnCancel = styled(Button)(({ theme }) => ({
  ...theme.radius.m,
  ...theme.fonts.header6,
  width: '100%',
  marginRight: 8,
  backgroundColor: theme.colors.grey75,
}));

const BtnSubmit = styled(Button)(({ theme, disabled }) => ({
  ...theme.radius.m,
  ...theme.fonts.header6,
  width: '100%',
  backgroundColor: theme.colors.green600,
  color: disabled ? theme.colors.grey500 : theme.colors.white,
  '&:hover': {
    backgroundColor: theme.colors.green400,
  },
}));

function CustomerDiscardAddress({
  onNext, onBack, onClose
}) {
  const deliveryControl = useDeliveryControlFlow();
  const word = useLanguage();

  return (
    <ModalInfo
      isOpen={deliveryControl.showModal}
      title={word('General.Alert.Unsave.Title')}
      description={word('General.Alert.Unsave.Description')}
      type="error"
      showCancel
      showIcon={false}
      cancelText={word('General.KeepEditing')}
      labelText={word('General.Discard')}
      onClose={onBack}
      isRed
      onConfirm={() => {
        deliveryControl.closeModal(true);
        sessionStorage.removeItem('addressEdits23p');
      }}
    />
  );
}

export default CustomerDiscardAddress;
